export const FEATURE_NAME = '@zerops/zerops/core/app-version-base';
